import { trackStructuredEvent } from "./TrackingUtil";

const nameString = (eventName: string) => "accountflyout." + eventName;

const tagsWithTierLevel = (tierLevel: string) => {
    return {
        tags: {
            tierLevel: tierLevel
        }
    };
};

export const trackMounted = (tierLevel: string) => {
    trackStructuredEvent(nameString("mounted"), tagsWithTierLevel(tierLevel));
};

export const trackAccountSwitch = (tierLevel: string) => {
    trackStructuredEvent(nameString("accountswitch"), tagsWithTierLevel(tierLevel));
};

export const trackLogout = (tierLevel: string) => {
    trackStructuredEvent(nameString("logout"), tagsWithTierLevel(tierLevel));
};

export const trackScriptLoadError = (tierLevel: string) => {
    trackStructuredEvent(nameString("loadscript.error"), tagsWithTierLevel(tierLevel));
};

export const trackListenerRegistrationError = (tierLevel: string) => {
    trackStructuredEvent(nameString("listenerregistration.error"), tagsWithTierLevel(tierLevel));
};

export const trackListenerRemovalError = (tierLevel: string) => {
    trackStructuredEvent(nameString("listenerremoval.error"), tagsWithTierLevel(tierLevel));
};

export const trackFallbackDisplayOnError = (tierLevel: string) => {
    trackStructuredEvent(nameString("renderfallback.error"), tagsWithTierLevel(tierLevel));
};
